import { MainContainerTheme } from "Themes/Metrics";
import styled from "styled-components";

export const MainContainer = styled(MainContainerTheme)`
  width: 60%;
`;

export const AddProjectImage = styled.div`
  border: solid 2px lightgray;
  border-radius: 100px;
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProjectIconsContainer = styled.div`
  display: flex;
  margin-top: 5%;
  justify-content: center;
  flex-wrap: wrap;
`;

export const ProjectIcon = styled.div`
  border: ${props =>
    props.selectedIcon ? "solid 2px green" : "solid 2px lightgray"};
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  padding: 10px;
  margin: 5px;
  opacity: ${props => (props.selectedIcon ? "1" : "0.5")};
  &:hover {
    opacity: 1
  }
`;

export const AddProjectImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;